import { createObjectKey } from './utils/create-object-key';
import type { AnnotationDeltaStatus, JournaledEventsConsumerDelegate, SyncEvent } from './types';
export class BackendSyncDelegate implements JournaledEventsConsumerDelegate {
  private readonly syncAnnotations: (events: readonly Readonly<SyncEvent>[]) => Promise<AnnotationDeltaStatus[]>;
  constructor(syncAnnotations: (events: readonly Readonly<SyncEvent>[]) => Promise<AnnotationDeltaStatus[]>) {
    this.syncAnnotations = syncAnnotations;
  }
  async consume(batch: readonly Readonly<SyncEvent>[]): Promise<Set<string>> {
    const statuses = await this.syncAnnotations(batch);
    const retain = new Set<string>();
    for (const s of statuses) {
      if (s.status === 'FAILED_PERMANENT') {
        console.error('[BackendSyncDelegate] Permanent sync failure', s);
      }
      if (s.status === 'FAILED_RETRYABLE') {
        const event = batch.find(e => e.annotationId === s.annotationId && e.frameIndex === s.frameIndex);
        if (event) {
          retain.add(createObjectKey(event.taskID, event.videoId, event.frameIndex, event.annotationId));
        }
      }
    }
    return retain;
  }
}